import { Object3D, Quaternion, Vector3 } from 'three';

/**
 * Rotates the object around the pivot point.
 * Note that rotating around a pivot point also affects the objects position in the world.
 *
 * @param objectToRotate
 * @param pivotPoint The point to rotate around in world coordinates.
 * @param quaternion The rotation to apply to the object
 */
export function rotateObjectAroundPivotPoint(
  objectToRotate: Object3D,
  pivotPoint: Vector3,
  quaternion: Quaternion,
) {
  const localPoint = objectToRotate.worldToLocal(pivotPoint.clone());

  objectToRotate.applyQuaternion(quaternion);

  // Update matrix world before we calculate the new position. Otherwise the rotation wont be taken into consideration
  objectToRotate.updateMatrixWorld(true);
  const worldPivotPointAfter = objectToRotate.localToWorld(localPoint.clone());

  // Calculate the diff between the pivot point before and adjust the position of the object accordingly
  const diff = pivotPoint.clone().sub(worldPivotPointAfter);
  objectToRotate.position.add(diff);
}
